import { v4 } from 'uuid';
import { getRootCookieDomain } from '@vp/tenant-resolution';
import { getCurrentCulture } from '@vp/culture-resolution';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var decodeContext = encodedContext => {
  if (!encodedContext) {
    return undefined;
  }

  try {
    return JSON.parse(window.atob(encodedContext));
  } catch (e) {
    console.error("Error decoding context", e);
  }

  return undefined;
};

var encodeContext = contextObj => {
  var jsonStr = JSON.stringify(contextObj);
  return window.btoa(jsonStr);
};

var CONTEXT_COOKIE_NAME = 'ftContext';

var getFeaturesContext = () => {
  var rawContext = document.cookie.split(';').find(c => c.trim().startsWith(CONTEXT_COOKIE_NAME));

  if (rawContext) {
    rawContext = rawContext.split('=')[1].trim();
    var context = decodeContext(rawContext);

    if (!context) {
      return generateAndWriteCookie();
    }

    if (!context.attributes || !context.attributes.culture) {
      context.attributes = _extends({}, context.attributes, {
        culture: getCurrentCulture()
      });
      return encodeContext(context);
    }

    return rawContext;
  }

  return generateAndWriteCookie();
};

var generateAndWriteCookie = () => {
  var encodedGeneratedContext = encodeContext({
    userId: v4(),
    attributes: {
      culture: getCurrentCulture()
    }
  });
  document.cookie = CONTEXT_COOKIE_NAME + "=" + encodedGeneratedContext + "; Path=/" + (location.hostname === 'localhost' ? '' : "; domain=" + getRootCookieDomain());
  return encodedGeneratedContext;
};

export { getFeaturesContext };
//# sourceMappingURL=ft-context-reader.esm.js.map
